/* RESPONSIBLE TEAM: team-standalone */
import { inject as service } from '@ember/service';
import type FinStandaloneService from 'embercom/services/fin-standalone-service';
import { default as BaseChannelRoute } from 'embercom/routes/apps/app/standalone/channels/base-channels';
import { IntegrationState } from 'embercom/objects/standalone/constants';
import type Transition from '@ember/routing/transition';
import type RouterService from '@ember/routing/router-service';

export default class FinStandaloneSalesforceCasesRoute extends BaseChannelRoute {
  @service declare appService: $TSFixMe;
  @service declare finStandaloneService: FinStandaloneService;
  @service declare router: RouterService;

  async beforeModel(transition: Transition) {
    super.beforeModel(transition);

    if (
      this.finStandaloneService?.salesforceConfig?.status === IntegrationState.Enabled ||
      this.finStandaloneService?.salesforceConfig?.status === IntegrationState.Paused
    ) {
      this.router.transitionTo('apps.app.standalone.deploy.salesforce.cases.go-live');
    } else {
      this.router.transitionTo('apps.app.standalone.deploy.salesforce.cases.connect');
    }
  }
}
